import { Country } from './models'

const CURRENCY_CONFIG = {
  CL: { currency: 'CLP', locale: 'es-CL' },
  MX: { currency: 'MXN', locale: 'es-MX' },
  PE: { currency: 'PEN', locale: 'es-PE' }
}

export const formatCurrency = (value: number, country: Country): string => {
  const config = CURRENCY_CONFIG[country]

  return new Intl.NumberFormat(config.locale, {
    // style: 'currency',
    // currency: config.currency,
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value)
}
